import React, { PropsWithChildren } from 'react';
import { AuthProvider } from './auth';
import { ThemeProvider } from './theme';

const AppProvider: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <ThemeProvider>
            <AuthProvider>
                {children}
            </AuthProvider>
        </ThemeProvider>
    );
}

export { AppProvider }